import {css, styled} from '@volkswagen-onehub/components-core';

// max-width tbd
export const StyledColumns = styled.div<{columns: number}>`
  ${({columns, theme}) => `
    display: grid;
    grid-template-columns: repeat(${columns}, minmax(auto, 1fr));
    column-gap: ${theme.size.dynamic0040};
    justify-content: center;
    ${
      columns === 2
        ? `> *:nth-child(3) {
        display: none;
      }`
        : null
    }
  `}
`;

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 48px;
`;

export const MaxWidthStyles = css`
  padding: 0 var(--size-grid002);
  width: 100%;
  max-width: 2560px;
`;

export const CategoryTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const CategoryHeaderCell = styled.th`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const FeaturesList = styled(StyledColumns).attrs({as: 'tr'})`
  column-gap: ${(props) => props.theme.size.dynamic0040};

  li[class^='StyledListItem'] {
    &::before {
      content: '';
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%) rotate(45deg); /* Rotate to form a checkmark */
      width: 5px;
      height: 12px;
      border: solid #00437a;
      border-width: 0 2px 2px 0;
    }
  }
`;

export const FeatureTable = styled(CategoryTable)``;

export const FeatureHeaderCell = styled(CategoryHeaderCell)``;
